<template>
<div class="topheader-user" @mouseleave="noticeLayerShow=false">
    <template v-if="currUser.userAgentId">
        <a-badge 
            v-if="notice.countList.length > 0"
            class="notice-badge" :class="{'bling': notice.total > 0}" :count="notice.total" @mouseover="noticeMouseOverHandle">
            <a-icon type="bell"/>
        </a-badge>
        <span style="margin-right:30px" @mouseover="noticeMouseOverHandle">{{currUser.displayName}}</span>
        <span @click="logout" style="cursor: pointer">
            <span>退出登录</span>
        </span>
        <NoticeCenter 
            v-show="noticeLayerShow" 
            pageType="layer" 
            @getTotal="(v) => { this.notice.total = v }"
            @getCountList="(v) => { this.notice.countList = v }"
        />
    </template>
</div>
</template>

<script> 
import { clearLoginUser } from "@/libs/global";
import { initDocumentTitle } from '@/libs/utils/notice'
import cookie from "@/libs/utils/cookie";
import NoticeCenter from "../components/notice/notice-center.vue";
export default {
    name: "HeaderAvatar",
    components: { NoticeCenter },
    data() {
        return {
            notice: {
                total: 0,
                countList: []
            },
            noticeLayerShow: false
        };
    },
    computed: {
        currUser() {
            return this.$store.state.account.user;
        }
    },
    methods: {
        logout() {
            this.$store.commit("account/clearuser");
            clearLoginUser();
            cookie.removeCookie("auth");
            localStorage.removeItem('userType')
            this.$router.push({
                path: "/frontPage/login"
            });
            initDocumentTitle()
            this.$eventBus.$emit('offNoticeSocket')
        },
        noticeMouseOverHandle () {
            if (this.notice.countList.length === 0) return
            this.noticeLayerShow = true 
            initDocumentTitle()
        }
    },
    mounted () {
        this.$eventBus.$on('noticeLayerShow', v => this.noticeLayerShow = v)
    },
    destory () {
        this.$eventBus.$off('noticeLayerShow')
    }
};
</script>

<style lang="less">
.topheader-user {
    position: relative;
    .notice-badge {
        margin-bottom: 5px;
        margin-right: 5px;
        cursor: pointer;
        .anticon-bell {
            font-size: 18px;
        }
        .ant-badge-count {
            height: 15px;
            min-width: 15px;
            line-height: 15px;
        }
        &.bling {
            .ant-badge-count {
                animation: bling 1s infinite;
            }
        }
    }
}
@keyframes bling {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/layouts/HeaderlAvatar.vue